import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { REQUEST_MENU_CURATION_TASK_SCRAPING_REVIEW_MUTATION } from '../graphql/mutations'
import { SCRAPING_REVIEW_COMMENTS_QUERY } from '../graphql/queries'
import {
  FETCH_SCRAPING_REVIEW_COMMENTS,
  REQUEST_MENU_CURATION_TASK_SCRAPING_REVIEW,
} from '../redux/action-types'

const useRequestMenuCurationTaskScrapingReviewMutation = () => {
  const dispatch = useDispatch()

  const { isRequestScrapingReviewLoading: isLoading, updateError: error } =
    useSelector(store => store.menuCurationTasks.menuCurationTask)

  const handleSuccess = useCallback(
    id =>
      apolloService.query({
        query: SCRAPING_REVIEW_COMMENTS_QUERY,
        variables: {
          id,
        },
        dispatch,
        action: FETCH_SCRAPING_REVIEW_COMMENTS,
      }),
    [dispatch],
  )

  const mutate = useCallback(
    (id, comment) =>
      apolloService.mutate({
        mutation: REQUEST_MENU_CURATION_TASK_SCRAPING_REVIEW_MUTATION,
        variables: { id, comment },
        dispatch,
        action: REQUEST_MENU_CURATION_TASK_SCRAPING_REVIEW,
        onSuccess: () => handleSuccess(id),
      }),
    [dispatch, handleSuccess],
  )

  return [mutate, { isLoading, error }]
}

export default useRequestMenuCurationTaskScrapingReviewMutation
